<template>
    <XWindow ref="window" :title="document.header.DocumentType === 'purchase-order' ? 'In Transit — Purchase Order' : 'In Transit — GRN'"
        windowClass="height-auto bts-window" scrollClass="collection height-auto" :width="1100" :height="600"
        :isMaximized="true" formStatus="view" @dialog-state="dialogState">
        <div class="p-3 form-custom-format" v-loading="loading">
            <h6>DOCUMENT DETAILS</h6>
            <div class="row">
                <div v-for="field in headerFields" :key="field.key" class="col-md-4">
                    <ThatsInput :label="field.label" :vid="'in-transit-' + field.key" :value="document.header[field.key]"
                        :readOnly="true" :rules="''" size="sm" labelClass="col-md-5" fieldClass="col-md-7 pl-0" />
                </div>
            </div>
            <el-alert v-if="error" :title="error" type="error" :closable="false" show-icon class="mb-2" />
            <h6>DOCUMENT ITEMS</h6>
            <p class="small text-muted">All original document lines are shown. Document and open quantities are not current in-transit or available stock.</p>
            <el-table class="custom-element-table" :data="document.items" row-key="LineNum" border stripe size="small"
                max-height="calc(100vh - 420px)" :empty-text="error ? 'Unable to load document items' : 'No document items'">
                <el-table-column prop="LineNum" label="Line" width="70" />
                <el-table-column prop="ItemCode" label="Item Code" min-width="180" />
                <el-table-column prop="Dscription" label="Item Description" min-width="250" />
                <el-table-column prop="WhsCode" label="Warehouse" width="130" />
                <el-table-column prop="UOM" label="UOM" width="100" />
                <el-table-column prop="Quantity" label="Document Qty." width="140" align="right" />
                <el-table-column prop="OpenQty" label="Open Document Qty." width="170" align="right" />
                <el-table-column prop="LineStatus" label="Line Status" width="120">
                    <template slot-scope="scope">{{ scope.row.LineStatus === 'O' ? 'Open' : (scope.row.LineStatus === 'C' ? 'Closed' : scope.row.LineStatus) }}</template>
                </el-table-column>
            </el-table>
            <h6 class="mt-3">LINKED GIT-01 DOCUMENTS</h6>
            <el-table :data="document.related" border stripe size="small" max-height="200" empty-text="No linked documents">
                <el-table-column label="Type" width="170">
                    <template slot-scope="scope">{{ scope.row.DocumentType === 'grn' ? 'GRN' : 'Purchase Order' }}</template>
                </el-table-column>
                <el-table-column prop="DocNum" label="Document No." width="160">
                    <template slot-scope="scope">
                        <el-button type="text" :disabled="loading" @click="openRelated(scope.row)">{{ scope.row.DocNum }}</el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="DocDate" label="Document Date" width="180" />
                <el-table-column prop="CardName" label="Vendor" min-width="200" />
            </el-table>
        </div>
        <template #left-button>
            <mdb-btn type="button" color="elegant" size="sm" :disabled="loading || !selected" @click="loadDocument"><i class="el-icon-refresh"></i> Refresh</mdb-btn>
        </template>
    </XWindow>
</template>

<script>
import { mapActions } from 'vuex';
import { mdbBtn } from 'mdbvue';
import XWindow from '../../components/thats/XWindow.vue';
import { ThatsInput } from '../../components/thats/Thats';

export default {
    name: 'InTransitDocumentForm',
    components: { XWindow, ThatsInput, mdbBtn },
    data() {
        return {
            document: { header: {}, items: [], related: [] },
            selected: null,
            loading: false,
            error: '',
            requestId: 0,
            headerFields: [
                { key: 'DocNum', label: 'Document No.' },
                { key: 'DocEntry', label: 'Document ID' },
                { key: 'DocDate', label: 'Document Date' },
                { key: 'DocDueDate', label: 'Due Date' },
                { key: 'CardCode', label: 'Vendor Code' },
                { key: 'CardName', label: 'Vendor Name' },
                { key: 'NumAtCard', label: 'Vendor Reference' },
                { key: 'DocStatus', label: 'Status (O=Open, C=Closed)' }
            ]
        };
    },
    beforeDestroy() {
        this.resetView();
    },
    methods: {
        ...mapActions('InTransitDocumentModule', ['getDocument']),
        openDialog(row, connection) {
            this.resetView();
            this.document.header = { ...row };
            this.selected = { docEntry: Number(row.DocEntry), type: row.DocumentType, connection };
            this.$refs.window.openDialog();
            return this.loadDocument();
        },
        openRelated(row) {
            return this.openDialog(row, this.selected.connection);
        },
        closeDialog() {
            this.resetView();
            this.$refs.window.closeDialog();
        },
        dialogState(open) {
            if (!open) this.resetView();
        },
        resetView() {
            this.requestId += 1;
            this.document = { header: {}, items: [], related: [] };
            this.selected = null;
            this.error = '';
            this.loading = false;
        },
        async loadDocument() {
            const requestId = ++this.requestId;
            this.document.items = [];
            this.document.related = [];
            this.error = '';
            if (!this.selected || !Number.isInteger(this.selected.docEntry) || this.selected.docEntry < 1
                || !['grn', 'purchase-order'].includes(this.selected.type)) {
                this.error = 'Invalid document selection.';
                return;
            }
            this.loading = true;
            try {
                const response = await this.getDocument({ ...this.selected });
                if (requestId !== this.requestId) return;
                const data = response && response.data;
                if (!data || !data.header || Number(data.header.DocEntry) !== this.selected.docEntry
                    || data.header.DocumentType !== this.selected.type || !Array.isArray(data.items) || !Array.isArray(data.related)) {
                    throw new Error('Invalid document response');
                }
                this.document = data;
            } catch (error) {
                if (requestId !== this.requestId) return;
                this.error = error.response && error.response.status === 404
                    ? 'This document no longer exists or is outside the in-transit document scope.'
                    : 'Unable to load this document. Please try Refresh again.';
            } finally {
                if (requestId === this.requestId) this.loading = false;
            }
        }
    }
};
</script>
